module.exports = __webpack_public_path__ + "media/images/new/icons/transparent_costs-f1e7dcb0247bd04b4dec13e00df5ac09.png";